import React from 'react'
import PropTypes from 'prop-types'

const ValidationMessage = ({ message }) => {
    return (<div className="form-error">{message}</div>)
}


export const ValidationMessageList = ({ validationMessageList }) => {
    if (!validationMessageList) {
        return null
    }
    return (
        <div>
            {validationMessageList.map(message => {
                return <ValidationMessage key={message.messageId} message={message.message}/>
            })}
        </div>
    )
}

ValidationMessageList.propTypes = {
    validationMessageList: PropTypes.array,
}

export default ValidationMessageList



// WEBPACK FOOTER //
// ./src/modules/validation/component/ValidationMessageList.js